
import GeneralMixin from './GeneralMixin';

const defaultFeatureInfo = {
    id: null,
    queryable: false,
    format: null,
    collapsible: false,
};

export default {
    mixins: [
        GeneralMixin,
    ],
    components: {
        MaterialColorPicker: () => import(/* webpackChunkName: "color-picker" */ '@/components/form/MaterialColorPicker.vue'),
        UploadMultipleImage: () => import(/* webpackChunkName: "upload-multiple-image" */ '@/components/form/UploadMultipleImage.vue'),
    },
    props: {
        groupTitle: {
            type: String,
            default: 'global.group',
        },
    },
    data() {
        return {
            loading: false,
            loadResources: false,
            lists: {
                loaded: false,
                onoff: [{'id': 1, 'name': 'Sim', 'code': true}, {'id': 2, 'name': 'Não', 'code': false}],
                groups: [],
            },
            form: {
                id: null,
                behavior: null,
            },
        }
    },
    mounted() {
        if(this.$route.params.type){
            this.form.behavior = this.$route.params.type;
        }

        this.loadLists();
        if(!this.form.id){
            this.loadResources=true;
        }
    },
    computed: {
        isLayer() {
            return this.form.behavior == 'resource';
        },
        detailTitle() {
            return this.isLayer ? this.pageTitle : this.$t(this.groupTitle);
        },
        titleItem() {
            return (this.form.id ? this.updateTitle : this.addTitle) + ' - ' + this.detailTitle;
        },
        groups() {
            return this.lists.groups || [];
        },
        baseTranslateID() {
            return this.pageID;
        },
        modelTranslateID() {
            return `${this.baseTranslateID}.model`;
        },
        helpTranslateID() {
            return `${this.baseTranslateID}.help`;
        },
    },
    methods: {
        callbackLoadItem: function() {
            this.loadResources=true;
            // [TODO] - melhorar isto
            ['icon_layer', 'legend_layer'].forEach(k => {
                if(this.form[k]){
                    this.form[k].forEach( item => {
                        this[k].push(item);
                        // this[k].push(Object.assign(item, {'path': item.filename}));
                    })
                }
            });

            if(!this.form.feature_info){
                this.form.feature_info = Object.assign({}, defaultFeatureInfo);
            }

            if(!this.form.featureable) {
                this.$set(this.form, 'featureable', {});
            }
        },
    },
    watch: {

    },
};
